// Set kur özet kartı (sektör paketleri DR1/DR15): büyük sayı "581 gösterge" (1,5rem/700) + paket
// başına sayılar + "27 ortak tek sayıldı" + "−5 çıkarıldı, +3 eklendi" + "41 üst otomatik · 9
// kırılımlı üyeleriyle" + birim ön seçimi; formül girdisi seçimde olmayan türetilmişler amber satır
// (bilgi, engellemez). ≤720 px kart yapışkan alt şeride iner (`narrow`). Kopya KPI_PACKAGES_COPY.

import type { SelectionSummary, UnresolvedRef } from "../../lib/kpi-package-selection";
import { KPI_PACKAGES_COPY } from "../../lib/kpi-packages-copy";
import { amberBox, helpText } from "./kpi-form-styles";

const S = KPI_PACKAGES_COPY.summary;

/** "yogunluk (ciro, enerji) · …" — en çok 5 kalem, kalanı "+N". */
export function unresolvedText(refs: readonly UnresolvedRef[]): string {
  const shown = refs.slice(0, 5).map((r) => S.unresolvedItem(r.code, r.missing.join(", ")));
  const rest = refs.length - shown.length;
  return S.unresolved(rest > 0 ? `${shown.join(" · ")} · +${rest}` : shown.join(" · "));
}

export function UnresolvedRefsNote(p: { refs: readonly UnresolvedRef[] }): JSX.Element | null {
  if (p.refs.length === 0) return null;
  return (
    <p style={{ ...amberBox, margin: 0 }} data-testid="kpi-unresolved-refs" aria-live="polite">
      {unresolvedText(p.refs)}
    </p>
  );
}

export function ForkSummaryCard(p: {
  summary: SelectionSummary;
  /** en az bir paket işaretli (paket satırları + çıkar/ekle sayıları) */
  withPackages: boolean;
  narrow: boolean;
  /** ≤720 px birincil düğme (İleri / Oluştur) yapışkan alt şeritte — K-B3 (TODO-UX-30) */
  action?: React.ReactNode;
}): JSX.Element {
  const { summary: s, withPackages, narrow } = p;
  const pkgLine = [
    ...s.perPackage.map((x) => S.perPackage(x.name, x.count)),
    ...(s.common > 0 ? [S.common(s.common)] : []),
  ].join(" · ");
  const lines = [
    withPackages && pkgLine ? pkgLine : null,
    withPackages && (s.removed > 0 || s.added > 0) ? S.removedAdded(s.removed, s.added) : null,
    s.ancestors > 0 || s.breakdownMembers > 0
      ? S.autoParents(s.ancestors, s.breakdownMembers)
      : null,
    s.unitPreselect > 0 ? S.unitPreselect(s.unitPreselect) : null,
  ].filter((l): l is string => l !== null);
  return (
    <section
      aria-label={S.title}
      data-testid="fork-summary"
      className="grid gap-2 rounded-lg p-3"
      style={{
        border: "1px solid var(--color-border)",
        background: "var(--color-surface)",
        alignContent: "start",
        ...(narrow
          ? { position: "sticky", bottom: 0, zIndex: 1, boxShadow: "0 -4px 12px rgba(0,0,0,0.06)" }
          : { position: "sticky", top: 0 }),
      }}
    >
      <div aria-live="polite" style={{ fontSize: "1.5rem", fontWeight: 700, lineHeight: 1.2 }}>
        {S.total(s.total)}
      </div>
      {lines.map((l) => (
        <div key={l} style={helpText}>
          {l}
        </div>
      ))}
      <UnresolvedRefsNote refs={s.unresolvedRefs} />
      {narrow && p.action ? (
        <div
          data-testid="fork-summary-action"
          className="flex"
          style={{ justifyContent: "flex-end" }}
        >
          {p.action}
        </div>
      ) : null}
    </section>
  );
}
